// 바쁨 문(판 #308 «클릭 0») — 받기·작업이 0 일 때만 화면 새로고침·CLI 업데이트를 스스로 한다.
// 바쁨 잣대는 CLI core/busy-gate.js 한 곳 — 이 탭은 제 바쁨을 /busy-beat 로 알리고, CLI 쪽 바쁨은 /health.busy 로 읽는다.
// 쓰던 입력도 사람 작업이라 화면 새로고침은 탭이 숨었거나 입력이 10분 없을 때만.

export const RELOAD_IDLE_MS = 10 * 60 * 1000

/** 이 탭이 지금 받기·작업 중인 까닭(store.state) — 비면 한가 */
export function tabBusyReasons(state) {
  const reasons = []
  const collecting = (state.collectingItems || []).length
  if (collecting) reasons.push(`수집 ${collecting}개`)
  if (state.pendingLedgerWrites > 0) reasons.push(`저장 ${state.pendingLedgerWrites}개`)
  const working = (state.workingScreens || []).length
  if (working) reasons.push(`작업 ${working}개`)
  return reasons
}

/** 새 화면 판 — 스스로 새로고침해도 되나 */
export function shouldAutoReload({ tabReasons, hidden, idleMs }) {
  if (tabReasons.length) return false
  return hidden || idleMs >= RELOAD_IDLE_MS
}

/** 새 CLI 판 — 'auto' 스스로 업데이트 · 'wait' 한가해질 때까지 배너만 · 'ask' 옛 CLI(busy 칸 없음)라 예전처럼 안내 */
export function cliUpdateMode({ tabReasons, cliBusy }) {
  if (!cliBusy || typeof cliBusy.busy !== 'boolean') return 'ask'
  return tabReasons.length || cliBusy.busy ? 'wait' : 'auto'
}

// 확장 판은 두 마디(10.112) — 마디마다 숫자로 비교(10.9 < 10.10). 판을 모르거나 형식이 틀리면 미만으로 보지 않는다(알릴 근거 없음)
// 서버 server.js extVersionBelow 와 같은 잣대
export function extVersionBelow(a, b) {
  const pa = String(a || '').split('.').map(Number)
  const pb = String(b || '').split('.').map(Number)
  if (!a || pa.some((n) => !Number.isFinite(n))) return false
  if (!b || pb.some((n) => !Number.isFinite(n))) return false
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    if ((pa[i] || 0) !== (pb[i] || 0)) return (pa[i] || 0) < (pb[i] || 0)
  }
  return false
}

/** 확장 업데이트 띠(판 #799 ⑥) — 'must' 하한 밑 · 'new' 최신보다 낮음 · null 띠 0(깔린 판·서버 값 모르면 지어내지 않는다) */
export function extUpdateBanner({ installed, latest, min }) {
  if (!installed) return null
  if (extVersionBelow(installed, min)) {
    return { kind: 'must', installed, target: extVersionBelow(min, latest) || latest === min ? latest : min }
  }
  if (extVersionBelow(installed, latest)) return { kind: 'new', installed, target: latest }
  return null
}
